jQuery(document).ready(function () {
  window.banderole();
});

window.banderole = function() {
  window.banderoleObject = {};
  window.banderoleObject.element = document.getElementById('banderole');
  window.banderoleObject.footer = document.getElementsByTagName('footer')[0];
  window.addEventListener('scroll', window.banderoleScroll);
}

window.isScrolledIntoView = function(el) {
  var rect = el.getBoundingClientRect();
  var elemTop = rect.top;
  var elemBottom = rect.bottom;
  // Only completely visible elements return true:
  //var isVisible = (elemTop >= 0) && (elemTop <= window.innerHeight);
  // Partially visible elements return true:
  var isVisible = elemTop < window.innerHeight && elemBottom >= 0;
  if (isVisible) {
    return window.innerHeight - elemTop;
  }
  return 0;
}

window.banderoleScroll = function() {

  if (!window.banderoleObject.element) {
    return;
  }

  var elementHeight = window.banderoleObject.element.offsetHeight;
  var distanceToTop = window.isScrolledIntoView(window.banderoleObject.footer)
  var scrollTop = document.documentElement.scrollTop;

  var opacity = 1;

  if (distanceToTop) {
    opacity = 1 - (distanceToTop / 200);
  }
  if (opacity >= 0) {
    window.banderoleObject.element.style.opacity = opacity;
    window.banderoleObject.element.style.zIndex = 2;
  } else {
    window.banderoleObject.element.style.zIndex = -1;
  }
}
